"use strict";
exports.__esModule = true;
var Constants_1 = require("../Constants");
var ExtendedData = (function () {
    function ExtendedData() {
        this._data = new Map();
    }
    ExtendedData.prototype.GetForEvent = function () {
        var extendedData = {
            activeUserId: this.ActiveUserId,
            sessionId: this.SessionId
        };
        this._data.forEach(function (value, key) {
            extendedData[key] = value;
        });
        return extendedData;
    };
    ExtendedData.prototype.HasKey = function (key) {
        return this._data.has(key);
    };
    ExtendedData.prototype.IsFull = function () {
        return this._data.size === Constants_1.EXTENDED_DATA_MAX_ENTRIES;
    };
    ExtendedData.prototype.SetData = function (key, value) {
        this._data.set(key, value);
    };
    ExtendedData.prototype.ClearAll = function (exceptions) {
        if (exceptions) {
            var keysToDelete = [];
            for (var dataKey in this._data.keys) {
                if (!(dataKey in exceptions)) {
                    keysToDelete.push(dataKey);
                }
            }
            for (var keyToDelete in keysToDelete) {
                this._data["delete"](keyToDelete);
            }
        }
        else {
            this._data.clear();
        }
    };
    return ExtendedData;
}());
exports.ExtendedData = ExtendedData;
//# sourceMappingURL=ExtendedData.js.map